// Input your warning message in between single quotes' ';
const warningTitleForShowBannedMessage = 'Text contains banned wordings/invalid characters';

// add words per line with comma.
// words should be lowercase.

const bannedWords = [
'boob',
'creampie',
'jizz',
'sperm',
'semen',
'cock',
'incest',
'porn',
'testical',
'pervert',
'cock',
'cuckold',
'clit',
'diu',
'dllm',
'dklm',
'bastard',
'bitch',
'fuck',
'shit',
'dipshit',
'apeshit',
'asshole',
'ass',
'damn',
'prick',
'arse',
'twat',
'nigga',
'niga',
'chink',
'blackie',
'nigger',
'racist',
'nazi',
'fascist',
'negro',
'rape',
'rapist',
'cannabis',
'weed',
'heroine',
'cocaine',
  'casetify',
  ' ',
  'nike',
  'adidas',
  'penis',
  'vagina',
  'lv',
  'gucci',
  'dior',
  'hermes',
  'nintendo',
  'disney',
  'pixar',
  'marvel',
  'sext',
  'burberry',
  'adererror',
'snowpeak',
'patagonia',
'gramicci',
'northface',
'tnf',
'goldwin',
'chanel',
'hermes',
'givenchy',
'fendi',
'ysl',
'dior',
'telfar',
'supreme',
'humanmade',
'jilsander',
'mm6',
'eastpak',
'herschel',
'lv',
'vuitton',
'kangol',
'babymilo',
'converse',
'carhartt',
'danton',
'dickies',
'helinox',
'karrimor',
'salomon',
'kitsune',
'loewe',
'miumiu',
'prada',
];